var site = site || {};

site.device = {};
site.window = {};
site.owl = {};
site.nav = {};
site.sidebar = {};
site.hero = {};

site.device.isTouch = function() {
	try {
		document.createEvent("TouchEvent");
		return true;
	} catch (e) {
		return false;
	}
};

site.window.scrollPosition = 0;

// Shorthand to init owlcarousel
site.owl.init = function(id, options) {
	var $owl = $(id);
	if ($owl.length > 0) {
		$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
		$owl.owlCarousel(options);
	}
};

// Init navigation scripts
site.nav.init = function() {
	// Add expand link to mobile menu
	//$('.children', '#mMenu ').prepend('<a class="expand" href="#"><span>+</span></a>');

	site.nav.bind();

	if (($('body').width() > 992 -15) && $('#mainmenu .gray li').hasClass('selectedLevel1')) {
		$('body').addClass('nav-open');
	}
};

// Bind events
site.nav.bind = function() {
	$('#navToggle').click(function(e) {
		$('body').toggleClass('nav-open');
	});
	// Mobile menu toggle
	$('#mainmenuToggle').click(function(e) {
		var menuOpen = $('body').hasClass('mainmenu-open');
		if (!menuOpen) {
			site.window.scrollPosition = $(window).scrollTop();
		}
		site.nav.mobileToggle(e, menuOpen, site.window.scrollPosition);
		e.preventDefault();
	});

	// yk in mobile menu
	$('.expand', '#mMenu').bind('click', function(e) {
		e.preventDefault();

		var $this = $(this);
		var $ul = $this.siblings('ul');

		$ul.toggleClass('hide');
		$this.next().toggleClass('down');
		$this.toggleClass('down');
		e.preventDefault();
	});
};

// Toggle mobile menu
site.nav.mobileToggle = function(e, menuOpen, scrollPosition) {
	$('body').toggleClass('mainmenu-open');
	$(this).toggleClass('open');
	if (!menuOpen) {
		$(window).scrollTop(0);
		$('i', '#mainmenuToggle').removeClass('fa-bars').addClass('fa-close');
	}
	else {
		$(window).scrollTop(scrollPosition);
		$('i', '#mainmenuToggle').removeClass('fa-close').addClass('fa-bars');
	}
};

// Append language to mobilemenu
site.nav.appendLanguage = function() {
	var $divisions = $('.menu', '#divisions');
	var $menu = $('ul.mmLevel1', '#mMenu');

	var $html = $('<li class="ele-language si level1"></li>');
	$divisions.find('li').each(function() {
		var $li = $(this).clone();
		$html.append($li.find('a'));
	});

	$menu.append($html);
};

site.search = {
	init : function() {
		$('#searchToggle').on('click', function (e) {
			e.preventDefault();
			$('body').toggleClass('search-open');

			$('body.search-open').on('click', function (e) {
				if (!$(e.target).parents('#searchBox').length && !$(e.target).parents('#searchToggle').length) {
					$('body').removeClass('search-open');
				}
			});

			if ($('body').hasClass('search-open')) {
				$('i', '#searchToggle').removeClass('fa-search').addClass('fa-close');
				$('#q').focus();
			}
			else {
				$('i', '#searchToggle').removeClass('fa-close').addClass('fa-search');
			}
		});
	}
};

site.frontpage = {
	init: function () {
		if (!$('body').hasClass('frontpage')) return;

		site.owl.init('.box.ljosmynd ul', {
			loop: false,
			dots: false,
			nav: true,
			items: 1,
			navText: ["", ""],
			margin: 30,
			responsive: {
				0: {
					items: 1,
					singleItem: true
				},
				480: {
					items: 2
				}
			},
			onDrag: function () {
				$('.box.ljosmynd .owl-controls').hide();
			},
			onDragged: function () {
				$('.box.ljosmynd .owl-controls').show();
			}
		});

		$('.boxCol .boxTitle h3').each(function() {
			var $moreLink = $('.entriesFooter a', $(this).closest('.box'));
			if ($moreLink.length) {
				$(this).wrapInner('<a href="'+$moreLink.attr('href')+'">')
			}
		});
	}
};

site.news = {
	initAdmin: function () {
		if (!$('body').hasClass('news admin')) return;
		if ($('form[name=news_form]').length > 0 && $('form[name=news_form]').prop('action').split('/').pop() == 'saveItem') {
			$('#news_published').prop('checked', true);
		}
	}
};

site.weather = {
	init: function() {
		if ($('.weatherMulti').length === 0) return false;
		site.weather.mWeather();
	},

	mWeather: function() {
		$('#mWeather').empty();
		$('.weatherData.selected', '.weatherMulti').clone().appendTo('#mWeather');
	}
};

// Run all the inits \o/
$(function() {
	site.nav.init();
	site.search.init();
	site.frontpage.init();
	site.news.initAdmin();
	site.weather.init();
	/*
	site.owl.init('#reviews > ul', {
		loop:true,
		nav:true,
		navText:["",""],
		items: 1
	});
	*/

	// Responsive vimeo player
	//var $i = $('iframe', '#center');
	//if ($i.length > 0 && $i.attr('src').indexOf('player.vimeo.com') != -1) {
	//	$i.wrap('<div class="vimeoPlayer"></div>');
	//}

	// Responsive tables
	$('table', '#center').wrap('<div class="responsiveTable"></div>');

	// Touch login
	$('.login').bind('click', function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	// Reorder language menu based on selected
	// Move is to the top
	$li = $('.selected', '#divisions');
	$ul = $('.menu', '#divisions');
	$ul.prepend($li);

	$('input[name=news_imagetext]').removeAttr('maxlength');
});
